export default {
    common: {
        confirm: "확인",
        cancel: "취소",
        close: "닫기",
        save: "저장",
        delete: "삭제",
        edit: "수정",
        copy: "복사",
        loading: "로딩 중...",
        error: "오류가 발생했습니다.",
        success: "성공.",
        webtoon: "웹툰",
        webnovel: "웹소설",
        cinenovel: "씨네-노벨",
        published: "발행됨",
        draft: "작성중",
        editor: "에디터"
    },
    footer: {
        terms: "이용약관",
        privacy: "개인정보처리방침",
        report: "권리침해신고",
        biz_ceo: "대표",
        biz_addr: "주소",
        biz_tel: "고객센터",
        biz_email: "이메일",
        biz_license: "사업자등록번호",
        biz_mail_order: "통신판매업신고",
        biz_none: "사업자 정보 미등록",
        system_ready: "SYSTEM READY",
        copyright: "SSULWHA WORLD"
    },
    auth: {
        attendance_success: "📅 출석 체크 완료! (Daily Rewards)\n오늘의 보너스 +50 포인트 지급!",
        attendance_title: "출석 보너스",
        signup_bonus: "환영합니다! 🎉\n가입 축하 보너스 +100 포인트 지급!",
        referral_bonus: "추천인 가입 완료! 🤝\n가입 보너스 100P + 추천 보너스 500P\n총 600 포인트가 지급되었습니다!",
        login_required: "로그인하고 더 많은 작품을 만나보세요."
    },
    social: {
        subscribe_on: "구독 리스트에 추가되었습니다.",
        subscribe_off: "구독이 취소되었습니다.",
        like_on: "좋아요를 눌렀습니다.",
        like_off: "좋아요를 취소했습니다."
    },
    comment: {
        submit_success: "댓글이 등록되었습니다.",
        delete_confirm: "이 댓글을 삭제하시겠습니까?",
        delete_success: "댓글이 삭제되었습니다.",
        empty_error: "내용을 입력해주세요.",
        delete_error: "삭제 실패",
        submit_error: "댓글 등록 실패"
    },
    payment: {
        verify_success: "결제 완료!\n{amount} 스타가 충전되었습니다.",
        verify_fail: "결제는 성공했으나 검증에 실패했습니다.",
        user_cancel: "결제를 취소했습니다.",
        error: "결제 중 오류가 발생했습니다."
    },
    menu: {
        home: "홈",
        webtoon: "웹툰",
        webnovel: "웹소설",
        novel: "웹소설",
        davinci: "다빈치",
        studio: "창작 스튜디오",
        library: "보관함",
        support: "고객센터",
        admin: "관리자 페이지",
        config: "외부 링크 설정",
        factory: "팝업/공지 관리",
        docs: "문서 에디터",
        analytics: "통계",
        plaza: "썰화 클럽",
        charge: "스타 충전소",
        wisdom: "별의 지혜",
        recommendation: "빈 서재",
        guide: "가이드",
        "whats-new": "새로운 소식",
        invite: "친구 초대",
        about: "서비스 소개",
        terms: "이용약관",
        privacy: "개인정보처리방침",
        report: "신고센터",
        "app-setting": "앱 설정",
        login: "로그인 / 회원가입",
        logout: "로그아웃",
        MyPage: "마이페이지",
        notice: "공지사항",
        proposal: "피드백",
        settings: "설정",
        language: "언어 설정"
    },
    modal: {
        translate_title: "언어 선택",
        translate_placeholder: "번역할 언어를 선택하세요.",
        translate_start: "번역 시작"
    },
    profile: {
        mypage: "마이페이지",
        follow: "팔로우",
        following: "팔로잉",
        followers: "팔로워",
        following_count: "팔로잉",
        bio_empty: "소개가 없습니다.",
        works: "작품",
        geo_desc: "우리는 마케팅을 하지 않습니다. AI가 대신 합니다.",
        term_log_1: "콘텐츠 분석 중...",
        term_log_2: "키워드 추출 중...",
        term_log_3: "SEO 메타데이터 주입 중...",
        term_log_4: "오가닉 트래픽 성장 +300%",

        // Missing Keys Added
        slider_old_title: "기존 방식",
        slider_old_desc: "원작을 가려버림",
        slider_new_title: "썰화 엔진 (R.A.P.S)",
        slider_new_desc_1: "\"이것이 원래 그랬어야 할 모습이다.\"",
        slider_new_desc_2: "텍스트가 자연스럽게 떠올라, 작화를 온전히 보존합니다.",

        phone_analyzing: "분석 중...",
        phone_detected: "감지됨",
        phone_text_1: "이게 내 운명인가?",
        phone_cine_ep: "시네-노벨 EP.01",
        phone_cine_text_1: "네온 사인이 깜빡이며 그의 차가운 눈동자에 비쳤다.",
        phone_cine_text_2: "\"단순한 번역이 아니야,\" 그가 중얼거렸다. \"새로운 현실이지.\"",

        footer_copyright: "Powered by R.A.P.S Engine.",
        feed: "피드",
        guestbook: "방명록",
        works_empty: "작품이 없습니다.",
        works_error: "작품 로드 실패",
        feed_empty: "피드가 없습니다.",
        feed_error: "피드 로드 실패",
        feed_error_detail: "인덱싱 중이거나 네트워크 오류일 수 있습니다.",
        follow_error: "팔로우 처리 중 오류가 발생했습니다."
    },
    support: {
        title: "1:1 문의",
        input_placeholder: "문의하실 내용을 입력하세요...",
        empty_state_title: "문의 내역이 없습니다.",
        empty_state_desc: "궁금한 점은 언제든지 물어보세요!",
        status_received: " 접수됨",
        auto_reply: "문의가 접수되었습니다. 순차적으로 답변드리겠습니다. 잠시만 기다려주세요.",
        send_fail: "메시지 전송 실패"
    },
    guestbook: {
        title: "방명록",
        input_placeholder: "응원의 한마디를 남겨주세요...",
        submit: "남기기",
        secret: "비밀글",
        empty: "첫 방명록을 남겨보세요!",
        reply: "답글",
        reply_placeholder: "답글을 입력하세요...",
        secret_content: "비밀글입니다 (작성자와 관리자만 볼 수 있습니다)",
        submit_error: "등록 실패: ",
        emoji_error: "이모지 로드 실패",
        confirm_delete_reply: "답글을 삭제하시겠습니까?"
    },
    author: {
        apply_title: "작가 신청",
        apply_desc: "당신의 이야기를 세상에 들려주세요. 간단한 소개와 포트폴리오를 남겨주시면 검토 후 연락드리겠습니다.",
        email_label: "이메일",
        email_placeholder: "연락받을 이메일 주소",
        email_hint: "승인 결과 및 계약 관련 연락을 드릴 수 있습니다.",
        intro_label: "자기소개",
        intro_placeholder: "자신을 소개해 주세요 (집필 경력, 작품 스타일 등)",
        portfolio_label: "포트폴리오 (선택사항)",
        submit_btn: "신청하기",
        email_required: "이메일을 입력해주세요.",
        intro_required: "자기소개를 입력해주세요.",
        submitting: "제출 중...",
        submit_success: "작가 신청이 완료되었습니다."
    },
    badge: {
        best_reviewer: "베스트 리뷰어",
        top_author: "인기 작가",
        vip: "VIP",
        donation_king: "후원왕",
        hall_of_fame: "명예의 전당"
    },
    point: {
        reason: {
            attendance: "출석 체크",
            reading: "작품 감상",
            reading_reward: "작품 감상 보상",
            welcome: "가입 환영 선물",
            referral: "추천인 보상",
            author_apply: "작가 신청 보상",
            rental: "대여",
            purchase: "소장",
            star_charge: "스타 충전",
            share: "공유 보상",
            completion: "작품 완독 보상",
            other: "기타"
        }
    },
    wallet: {
        tab_title: "월렛",
        sub_card: {
            upgrade_btn: "멤버십 업그레이드 ({price}/월)",
            coming_soon: "준비 중",
            tier_label: "멤버십 등급",
            tier_premium: "프리미엄 패스",
            tier_standard: "스탠다드 회원",
            renews_on: "갱신일"
        },
        assets: {
            activity_label: "Activity Points",
            activity_desc: "무료 적립 포인트",
            star_label: "Star Points",
            star_desc: "유료 충전 포인트"
        },
        charge: {
            title: "스타 충전소",
            desc: "부족한 별을 충전하세요"
        },
        history: {
            title: "포인트 내역",
            empty: "내역이 없습니다."
        }
    },
    history: {
        empty: {
            title: "아직 감상한 작품이 없네요.",
            desc: "어떤 작품들이 있는지 둘러볼까요?",
            action_btn: "작품 둘러보기"
        },
        common: {
            no_title: "제목 없음"
        },
        last_viewed: "마지막 감상:",
        episode_fmt: "{n}화",
        delete_confirm: {
            msg: "이 기록을 삭제하시겠습니까?",
            title: "기록 삭제"
        }
    },
    library: {
        empty_title: "보관함이 비었습니다.",
        empty_desc: "구매하거나 감상한 작품이 여기에 표시됩니다.",
        explore_btn: "작품 둘러보기",
        select_hint: "목록을 보려면 작품을 선택하세요.",
        total_episodes: "총 {n}화"
    },
    tab: {
        works: "작품",
        feed: "썰화 (피드)",
        guestbook: "방명록"
    },
    tag: {
        fantasy: "판타지",
        romance: "로맨스",
        martial_arts: "무협",
        drama: "드라마",
        slice_of_life: "일상",
        comedy: "개그",
        thriller: "스릴러",
        school: "학원",
        munchkin: "먼치킨",
        regression: "회귀",
        possession: "빙의",
        system: "시스템",
        growth: "성장",
        revenge: "복수",
        heart: "순정",
        horror: "호러",
        sport: "스포츠",
        history: "대체역사"
    },
    pwa: {
        install_title: "앱 설치하기",
        install_desc: "더 빠르고 쾌적한 환경에서 감상하세요.",
        install_btn: "설치",
        later_btn: "나중에",
        ios_guide_title: "아이폰에 앱 설치하기",
        ios_guide_desc: "더 넓은 화면으로 쾌적하게 감상하세요.",
        ios_step1: "공유 버튼을 눌러주세요",
        ios_step2: "'홈 화면에 추가'를 선택하세요",
        update_title: "새로운 버전 ({version}) 출시!",
        update_title_v2: "새로운 버전이 업데이트되었습니다!",
        update_desc: "지금 업데이트하고 최신 기능을 경험하세요.",
        update_btn: "업데이트",
        updating: "업데이트 중...",
        offline_title: "오프라인 상태입니다",
        offline_desc: "인터넷 연결을 확인해주세요.",
        copy_success: "클립보드에 복사되었습니다.",
        copy_fail: "복사 실패"
    },
    settings: {
        title: "앱 설정",
        general: "일반 설정",
        push_title: "푸시 알림",
        push_desc: "새로운 소식 알림 받기",
        app_info: "앱 정보",
        current_version: "현재 버전",
        danger_zone: "Danger Zone",
        delete_account_title: "회원 탈퇴 (Return to Reality)",
        delete_account_desc: "모든 데이터가 삭제되며 복구할 수 없습니다.",
        delete_account_button: "현실 세계로 복귀"
    },
    proposal: {
        title: "별의 지혜",
        desc: "당신의 빛나는 지혜가 우주를 넓힙니다.",
        label_title: "제안 제목",
        placeholder_title: "아이디어의 핵심을 적어주세요",
        label_content: "상세 내용",
        placeholder_content: "자유롭게 의견을 남겨주세요. 구체적일수록 좋아요!",
        btn_submit: "지혜 보내기",
        success_title: "지혜가 도착했습니다",
        success_desc: "{name}님의 지혜가 무사히 전달되었습니다.<br>소중한 의견 감사합니다."
    },
    report: {
        title: "신고센터",
        category_label: "신고 유형",
        content_label: "신고 내용",
        url_label: "관련 URL",
        categories: {
            general: "일반 문의 / 기타",
            spam: "스팸 / 홍보",
            abuse: "욕설 / 비하 발언",
            adult: "음란물 / 청소년 유해",
            bug: "시스템 버그 / 오류"
        },
        placeholder_content: "문제가 되는 내용을 상세히 적어주세요.",
        btn_submit: "신고하기",
        warning: "허위 신고 시 서비스 이용이 제한될 수 있습니다.",
        success_title: "신고 접수 완료",
        success_desc: "내용 확인 후 신속히 조치하겠습니다.<br>제보해주셔서 감사합니다.",
        login_required: "로그인이 필요합니다.",
        submit_success: "신고가 접수되었습니다.",
        error: "신고 접수 중 오류 발생",
        modal: {
            title: "신고하기",
            desc: "신고 사유를 선택해주세요. 허위 신고 시 제재될 수 있습니다.",
            category: "유형",
            detail: "상세 내용",
            url: "관련 링크",
            submit: "제출",
            cancel: "취소"
        },
        reason: {
            spam: "스팸 / 홍보",
            abusive: "욕설 / 비하",
            inappropriate: "부적절한 콘텐츠",
            other: "기타 / 문의"
        }
    },
    guide: {
        title: "시스템 조율 중",
        desc: "여러분의 여정을 돕기 위해<br>나침반을 정교하게 다듬고 있습니다.",
        wait: "잠시만 기다려주세요."
    },
    seo: {
        default_title: "썰화 월드 - 상상이 현실이 되는 곳",
        default_desc: "AI 기반 웹툰 & 웹소설 플랫폼. 당신의 이야기로 우주를 만들어보세요."
    },
    placeholder: {
        search: "작품, 작가, 태그 검색...",
        comment: "댓글을 남겨주세요...",
        guest_book: "응원의 메시지를 남겨주세요!",
        title_required: "제목을 입력해주세요.",
        content_required: "내용을 입력해주세요."
    },
    toast: {
        login_success: "로그인되었습니다.",
        copy_success: "클립보드에 복사되었습니다.",
        network_error: "네트워크 오류가 발생했습니다.",
        processing: "처리 중..."
    },
    msg: {
        welcome_beta: "미리내 플랫폼 베타 서비스에 오신 것을 환영합니다.",
        login_required: "로그인하고 더 많은 이야기를 만나보세요.",
        login_btn: "로그인 / 회원가입"
    },
    viewer: {
        settings_title: "감상 설정",
        bgm_volume: "BGM 볼륨",
        bgm_off: "BGM 끄기",
        auto_speed: "자동 넘김 속도",
        settings_btn: "설정",
        translate_btn: "AI 번역",
        tts_btn: "듣기 (TTS)",
        bgm_btn: "BGM",
        top_btn: "맨 위로",
        auto_play: "자동 넘김",
        auto_scroll: "자동 스크롤",
        start_auto: "자동 넘김 시작",
        stop_auto: "자동 넘김 중지",
        tts_warn: "알림: TTS는 원문 언어(한국어)로 재생됩니다."
    },
    login: {
        subtitle: "당신의 상상이 현실이 되는 곳",
        btn_google: "Google로 계속하기",
        or: "또는",
        label_email: "이메일",
        label_password: "비밀번호",
        label_password_confirm: "비밀번호 확인",
        btn_email_login: "이메일로 로그인",
        btn_email_signup: "이메일로 가입하기",
        msg_no_account: "계정이 없으신가요?",
        msg_has_account: "이미 계정이 있으신가요?",
        btn_signup: "회원가입",
        btn_login: "로그인",
        msg_processing: "처리 중...",
        msg_email_sent: "인증 메일이 발송되었습니다. 확인 후 로그인해주세요.",
        msg_signup_success: "가입 완료",
        err_password_mismatch: "비밀번호가 일치하지 않습니다.",
        err_invalid_auth: "이메일 또는 비밀번호가 올바르지 않습니다.",
        err_email_in_use: "이미 사용 중인 이메일입니다.",
        err_default: "오류가 발생했습니다."
    },
    terms: {
        title: "입국 심사",
        desc: "썰화 월드에 오신 것을 환영합니다.<br>이용약관에 동의하고 입국하세요.",
        required: "[필수]",
        optional: "[선택]",
        label_terms: "서비스 이용약관",
        label_privacy: "개인정보 처리방침",
        label_marketing: "마케팅 정보 수신 동의",
        btn_start: "시작하기",
        btn_processing: "처리 중..."
    },
    main: {
        banner_welcome: " 즐거움이 가득한 썰화 월드!",
        search_placeholder: "작품, 작가, 태그 검색...",
        hall_of_fame: "명예의 전당 (주간 베스트)",
        hall_of_fame_locked: "명예의 전당은 회원 전용입니다",
        hall_of_fame_desc: "이번 주 가장 활발한 활동가는 누구일까요? 로그인하고 실시간 랭킹을 확인하세요!",
        login_btn: "로그인 하러 가기",
        todays_pick: "오늘의 픽",
        continue_reading: "이어보기",
        trending: "지금 뜨는 작품",
        new_arrivals: "신규 작품",
        all_works: "전체 작품",
        tag_cloud: "태그로 탐색",
        filter_all: "전체",
        filter_webtoon: "웹툰",
        filter_webnovel: "웹소설",
        realtime_club: "실시간 썰화 클럽",
        enter_club: "클럽 입장",
        be_the_first: "가장 먼저 별을 쏘아올려보세요!",
        go_to_plaza: "광장으로 이동",
        search_results: "'{query}' 검색 결과",
        search_no_results: "검색 결과가 없습니다.",
        search_try_other: "다른 검색어로 찾아보세요.",
        splash_loading: "썰화 월드 입장 중..."
    },
    mypage: {
        tab_library: "보관함",
        tab_history: "최근 본 작품",
        tab_activity: "활동",
        tab_likes: "좋아요",
        tab_wallet: "월렛",
        tab_settings: "설정",
        no_activity: "아직 활동 내역이 없습니다.",
        go_to_plaza: "클럽 가기",
        followers: "팔로워",
        following: "팔로잉",
        edit_profile_tooltip: "프로필 수정",
        role_author: "작가",
        role_reader: "독자",
        role_admin: "관리자",
        author_pending: " 작가 승인 대기 중",
        btn_studio: "창작 스튜디오",
        btn_apply_author: "작가 신청",
        default_bio: "한 줄 소개를 입력해주세요.",
        menu_edit_profile: "프로필 수정",
        menu_public_profile: "공개 프로필 보기",
        current_version: "버전 정보",
        invite_title: "친구 초대",
        invite_reward: "보상 +500P",
        invite_reward_prefix: "보상",
        invite_desc: "친구에게 초대 링크를 공유하세요. 두 분 모두에게 500P를 드립니다!",
        invite_desc_template: "친구에게 초대 링크를 공유하세요. 두 분 모두에게 {amount}P를 드립니다!",
        invited_count: "초대한 친구",
        unit_people: "명",
        edit_profile_title: "프로필 수정",
        label_photo: "프로필 사진",
        btn_upload: "업로드",
        btn_random: "랜덤 생성",
        placeholder_photo_url: "또는 이미지 URL 입력",
        label_nickname: "닉네임",
        label_bio: "한 줄 소개",
        placeholder_bio: "나를 한 줄로 표현해보세요."
    },
    plaza: {
        title: "SSULWHA CLUB",
        subtitle: "Z세대의 감성 소통 공간, 썰화 클럽",
        btn_sync: " 댓글 카운트 동기화 (Admin Only)",
        composer_placeholder_init: "이 우주에 어떤 이야기를 띄우고 싶으신가요?",
        composer_placeholder_thread: "이어지는 이야기를 적어주세요...",
        composer_placeholder_quote: "이 이야기에 대한 생각을 남겨주세요...",
        btn_add_thread: "스레드 추가",
        btn_submit: "별 띄우기",
        btn_submit_quote: "인용하기",
        btn_submitting: "업로드 중...",
        quote_suffix: "님을 인용함"
    },
    recommendation: {
        loading_title: "당신의 궤적을 읽고 있습니다...",
        loading_desc: "지나온 발자국과 머물렀던 별들을 연결하는 중",
        fallback_title: "<span class=\"text-transparent bg-clip-text bg-gradient-to-r from-fuchsia-200 to-amber-200\">아직은 {name}님</span>의 별자리가<br>희미하게 보입니다.",
        fallback_desc: "하지만 걱정 마세요. <br>많은 이들의 밤을 밝혀준 빛나는 이야기들을 먼저 골라두었습니다.<br><span class=\"text-sm opacity-70 mt-1 block\">당신의 발자국이 조금 더 쌓이면, 오직 당신만을 위한 궤도를 찾아드리겠습니다.</span>",
        personal_title: "<span class=\"text-transparent bg-clip-text bg-gradient-to-r from-fuchsia-200 to-amber-200\">{name}</span>님의 서재,<br>그 다음 칸에 놓일 이야기",
        personal_desc: "당신의 취향과 공명하는 5개의 별을 찾았습니다.",
        label_empty_shelf: "서재의 빈칸 (The Empty Shelf)",
        btn_refresh: "다른 추천 받기",
        error_title: "연결이 불안정합니다",
        btn_retry: "다시 시도",
        empty_data_title: "아직 데이터가 충분하지 않아요",
        btn_browse: "작품 둘러보기",
        widget_title: "다음에 읽을 책을<br>찾고 계신가요?",
        widget_desc: "{name}님의 취향을 분석하여 5개의 작품을 엄선했습니다.",
        widget_desc_guest: "당신의 취향을 분석하여 5개의 작품을 엄선했습니다.",
        btn_check: "추천 확인하기"
    },
    star_station: {
        title: "스타 충전소",
        subtitle: "작품을 더 자유롭게 감상하세요.",
        my_stars: "보유 스타",
        history_tab: "충전 내역",
        products_tab: "상품 목록",
        payment_method: "결제 수단",
        btn_charge: "충전하기",
        history_empty: "충전 내역이 없습니다.",
        product_names: {
            stardust: "스타 더스트",
            shooting_star: "슈팅 스타",
            little_bear: "리틀 베어",
            silver_river: "실버 리버",
            galaxy_master: "갤럭시 마스터",
            star_maker: "스타 메이커"
        }
    },
    studio: {
        title: "창작 스튜디오",
        open_menu: "메뉴 열기",
        exit: "나가기",
        new_series: "새 시리즈",
        lab_badge: "LAB",
        lab_title: "다빈치 실험실",
        lab_desc: "AI와 함께하는 새로운 창작의 세계를 경험해보세요.",
        total_views: "총 조회수",
        total_likes: "총 좋아요",
        total_followers: "팔로워",
        weekly_performance: "주간 성과",
        views_trend_7d: "최근 7일 조회수 트렌드",
        live_data: "실시간",
        my_series_list: "내 작품 목록",
        total_series_count: "총 {n}개의 작품",
        empty_series_title: "새로운 이야기를 시작해보세요",
        empty_series_desc: "당신의 상상력을 세상에 펼쳐보세요.",
        btn_editor: "에디터",
        btn_settings: "설정",
        btn_delete: "삭제",
        delete_modal_title: "작품 삭제",
        delete_modal_content: "정말로 '{title}' 작품을 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다.",
        create_first_episode: "첫 에피소드를 만들어보세요!",
        create_first_episode_desc: "새 에피소드 버튼을 눌러 시작하세요.",
        last_updated: "마지막 수정: {date}",
        delete_episode_title: "에피소드 삭제",
        delete_episode_content: "'{title}' 에피소드를 삭제하시겠습니까?",
        bold: "굵게",
        italic: "기울임",
        highlight_red: "강조(Red)",
        highlight_blue: "강조(Blue)",
        save_preserve_status: "현재 상태 유지하며 저장"
    },
    editor: {
        back_to_list: "목록으로 돌아가기",
        new_episode: "새 에피소드",
        untitled_episode: "제목 없는 에피소드",
        edit: "수정",
        delete: "삭제",
        webtoon_editor: "웹툰 에디터",
        episode_prefix: "Episode",
        preview: "미리보기",
        live_preview: "실시간 미리보기",
        preview_hint: "미리보기를 확인하세요",
        input_title_placeholder: "에피소드 제목을 입력하세요",
        display_mode: "디스플레이 모드",
        mode_webtoon: "세로 스크롤 (Webtoon)",
        mode_comic: "가로 보기 (Comics)",
        mode_insta: "인스타툰 (InstaToon)",
        mode_desc: "모드에 따라 미리보기 방식이 변경됩니다.",
        thumbnail: "썸네일",
        upload_image: "이미지 업로드",
        bgm: "배경음악 (BGM)",
        manuscript_images: "원고 이미지",
        drag_drop_hint: "이미지를 드래그하거나 클릭하여 업로드하세요.",
        save: "저장",
        save_draft: "임시 저장",
        save_changes: "변경사항 저장",
        publish: "발행",
        publish_now: "지금 발행",
        set_draft: "비공개 전환",
        publish_settings: "발행 설정",
        saving: "저장 중...",
        saved: "저장됨",
        processing: "처리 중...",
        publish_confirm: "발행하시겠습니까?",
        publish_complete: "발행 완료",
        publish_success: "성공적으로 발행되었습니다.",
        published: "발행됨",
        published_start_ai: "발행 및 AI 분석 시작",
        save_complete: "저장 완료",
        save_required: "저장이 필요합니다.",
        upload_complete: "업로드 완료",
        upload_fail: "업로드 실패",
        upload_fail_desc: "이미지 업로드에 실패했습니다.",
        draft_mode_title: "임시 저장 모드",
        draft_mode_private_desc: "현재 비공개 상태입니다.",
        draft_mode_switched: "비공개로 전환되었습니다.",
        image_mode_mismatch: "이미지 규격 불일치",
        invalid_format: "잘못된 형식",
        mode_change_blocked_desc: "이미지가 있어 모드를 변경할 수 없습니다.",
        mode_change_blocked: "모드 변경 불가",
        tap_nav_hint: "좌우로 탭하여 이동",
        ai_analyze_admin: "AI 분석 (관리자)",
        ai_analyze_local: "AI 문맥 분석",
        ai_analyze_confirm: "AI 분석을 시작하시겠습니까?",
        ai_confirm: "AI 확인",
        ai_context_analysis_confirm: "문맥 분석을 실행하시겠습니까? (기존 데이터 덮어쓰기)",
        ai_analyze_title: "AI 분석",
        ai_requesting: "AI 분석 요청 중...",
        ai_analyzing: "분석 중...",
        ai_analyzing_background: "백그라운드에서 AI 분석을 시작합니다...",
        ai_processing_title: "처리 중",
        ai_no_items: "분석할 항목이 없습니다.\n{log}",
        ai_no_items_found: "분석 대상이 없습니다.",
        diagnosis_report: "진단 리포트",
        ocr_complete: "이미지 분석 완료 ({n}장)",
        seo_trigger: "SEO 데이터 생성이 예약되었습니다.",
        ai_complete_desc: "AI 분석 완료.",
        ai_error: "AI 분석 오류",
        ai_fail_msg: "AI 분석 실패: {e}",
        title: "Novel Studio",
        master_detail: "Master-Detail View",
        complete: "저장 완료",
        pending_approval: "승인 대기 중",
        approval_requested: "승인 요청 완료",
        approval_desc: "작품이 승인 대기열에 등록되었습니다.\n관리자 검토 후 정식으로 공개됩니다.",
        error: "오류",
        ai_analyze_btn: "AI 분석",
        series_info: "시리즈 정보",
        series_title: "시리즈 제목",
        tags: "태그",
        admin_readonly: "관리자 전용",
        chapters: "챕터 목록",
        add_chapter: "챕터 추가",
        delete_chapter_confirm: "챕터를 삭제하시겠습니까?",
        episode_title: "에피소드 제목",
        bgm_label: "BGM 라벨",
        content_body: "본문 내용",
        load_txt: "TXT 불러오기",
        creating_episode: "에피소드 생성 중...",
        episode_not_found: "에피소드를 찾을 수 없습니다.",
        uploading_images_toast: "이미지 업로드 중...",
        approval_request_sent: "승인 요청이 전송되었습니다.",
        temp_saved_toast: "임시 저장되었습니다.",
        deleted_toast: "삭제되었습니다.",
        access_denied: "접근 거부",
        series_status: "시리즈 상태",
        admin_info: "관리자 정보",
        series_info_upload: "시리즈 정보 (업로드)",
        cover_upload_fail: "커버 업로드 실패: ",
        save_success: "저장 완료",
        delete_episode_content: "'{title}' 에피소드를 삭제하시겠습니까?",
        text_too_short: "내용이 너무 짧습니다.",
        upload_cover_fail: "커버 업로드 실패",
        create_series: "새 시리즈 생성",
        edit_series: "시리즈 수정",
        basic_info: "기본 정보",
        episode_mgmt: "에피소드 관리",
        compliance: "규정 준수 (Compliance)",
        age_rating: "연령 등급 (Age Rating)",
        age_guide: "심의 가이드",
        is_ai: "AI 생성 콘텐츠 사용",
        is_ai_desc: "이 작품에 AI로 생성한 텍스트나 이미지가 포함되어 있나요?",
        free_limit: "무료 회차 (Free Limit)",
        free_limit_placeholder: "비워둘 시 전역/작품별 기본값 적용",
        free_limit_desc: "* 값을 입력하면 전역 설정보다 우선 적용됩니다. (0 입력 시 유료화)",
        admin_edit_anytime: "* 관리자 권한으로 언제든지 수정 가능합니다.",
        desc_placeholder: "작품 줄거리를 입력하세요...",
        cover_image: "커버 이미지",
        cover_url: "표지 URL",
        format: "형식 (Format)",
        format_locked: "변경 불가",
        webtoon: "웹툰 (Webtoon)",
        webnovel: "웹소설 (Webnovel)",
        cinenovel: "씨네-노벨 (Cine-Novel)",
        admin_id: "식별 코드 (Admin Only)",
        cancel: "취소",
        create: "작품 생성",
        episode_list: "에피소드 목록",
        status_published: "발행됨",
        status_draft: "작성중",
        edit_detail_guide: "상세 수정은 에디터에서",
        refreshing_list: "목록 새로고침 중...",
        load_fail: "목록 로드 실패: ",
        no_cover: "표지 없음",
        badge_ai: "AI 생성",
        no_episodes: "아직 등록된 에피소드가 없습니다.",
        open_editor_fullscreen: "에디터 열기 (전체화면)",
        editor_guide_text: "* 순서 변경 및 상세 수정은 '에디터 열기'를 통해 진행해주세요.",
        admin_zone: "관리자 전용 구역",
        admin_zone_desc: "이 정보는 일반 사용자에게는 노출되지 않거나, 제한적으로 표시됩니다.",
        download_csv: "ISBN 신청용 CSV 다운로드",
        adult_confirm_title: "성인물 설정 경고",
        adult_confirm_body: "이 작품을 '성인물(19세 이상 이용가)'로 설정하시겠습니까?\n\n- 미성년자의 접근이 차단됩니다.\n- 본인인증이 필요할 수 있습니다.",
        davinci_lock_title: " 준비 중입니다",
        davinci_lock_desc: "다빈치 모드(씨네-노벨)는 현재 안정화 작업 중이며,<br>작가님들의 혼란을 방지하기 위해 <strong>관리자 권한 계정</strong>만 접근 가능합니다.<br><div class='mt-3 text-rose-400 font-bold'>빠른 시일 내에 공개될 예정입니다.</div>",
        preview_preparing: "미리보기 준비 중...",
        select_chapter: "에피소드를 선택하세요",
        episode_placeholder: "예) 1화. 시작",
        bgm_placeholder: "Suno AI URL 입력...",
        ai_analysis_fail: "AI 분석 실패: ",
        save_fail: "저장 실패: ",
        novel_editor: "웹소설 에디터",
        auto_saved: "자동 저장됨",
        untitled_chapter: "제목 없음",
        chapter_title_placeholder: "챕터 제목",
        delete_title: "챕터 삭제",
        save_button: "저장하기",
        novel_info: "소설 정보",
        novel_title: "소설 제목",
        tags_placeholder: "로맨스, 판타지, 성장",
        chapter_count: "총 {n}화",
        add_empty_chapter: "빈 챕터 추가하기",
        public_toggle: "공개 (Published)",
        private_toggle: "비공개 (Draft)",
        bgm_suno_label: "BGM 설정 (Suno 자동변환)",
        txt_upload: "텍스트 파일 업로드 (.txt)",
        content_placeholder: "소설 내용을 입력하세요...",
        note_placeholder: "독자들에게 남길 말을 적어주세요...",
        ai_analysis_complete: " AI 분석 완료",
        recommend_keywords: "추천 키워드",
        hook: "Hook",
        analysis_saved: "* 분석 데이터(SEO)가 서버에 저장되었습니다.",
        analysis_fail: "AI 분석 실패",
        analysis_short: "분석할 내용이 너무 적습니다.",
        age_all: "All",
        age_12: "12+",
        age_15: "15+",
        age_19: "19+",
        rating_label: "Rating",
        age_19_desc: "* 19세 이용가를 선택할 경우, 미성년자의 접근이 차단되며 본인인증이 요구됩니다.",
        age_lock_warning: "주의: 선택 후 저장하면 작가는 직접 수정할 수 없으며, 관리자 문의가 필요합니다.",
        preview_desc: "모바일 화면에서 어떻게 보일지 확인하세요."
    },
    rating_guide: {
        title: "콘텐츠 등급 기준 가이드",
        all_title: "전체 이용가 (All Ages)",
        all_desc: "모든 연령대가 이용할 수 있는 건전한 내용의 콘텐츠입니다.<br>폭력성, 선정성, 언어 부적절성이 없거나 매우 경미합니다.",
        title_12: "12세 이용가 (12+)",
        desc_12: "경미한 수준의 폭력, 비속어, 공포 등이 포함될 수 있습니다.<br>12세 미만 아동은 보호자의 지도가 권장됩니다.",
        title_15: "15세 이용가 (15+)",
        desc_15: "다소 높은 수위의 주제, 폭력, 언어 등이 포함될 수 있습니다.<br>범죄 모방의 위험이 있거나 사회적 통념에 반하는 내용이 일부 포함될 수 있습니다.",
        title_19: "청소년 관람불가 (19+)",
        desc_19: "직설적이고 구체적인 선정적 표현, 과도한 폭력, 욕설 등이 포함됩니다.<br><strong class='text-red-500'>법적으로 만 19세 미만의 청소년은 이용할 수 없으며, 본인인증이 강제됩니다.</strong>",
        disclaimer: "* 등급 설정은 작가의 책임하에 이루어지며, 허위 설정 시 관리자에 의해 강제 변경되거나 제재를 받을 수 있습니다.",
        confirm: "확인했습니다"
    },
    davinci: {
        episode_settings: "에피소드 설정",
        title: "제목",
        thumbnail: "썸네일",
        bgm: "배경음악 (BGM)",
        add_block: "블록 추가",
        text_block: "텍스트",
        image_block: "이미지",
        upload_image: "이미지 업로드",
        upload_thumb: "썸네일 업로드",
        upload_success: "업로드 성공",
        bgm_placeholder: "Suno URL 또는 MP3 링크",
        tip: "Tip:",
        drag_tip: "블록을 드래그하여 순서를 변경할 수 있습니다.",
        project_settings: "프로젝트 설정",
        isbn: "ISBN (선택)",
        isbn_placeholder: "ISBN 번호 입력",
        dark_mode: "다크 모드",
        auto_save: "자동 저장",
        scene_direction: "장면 연출",
        camera_movement: "카메라 워킹",
        transition: "화면 전환",
        effect: "특수 효과",
        cut_edit: "컷 편집",
        merge_cuts: "컷 병합",
        split_cut: "컷 분할",
        delete_cut: "컷 삭제",
        ai_tools: "AI 도구",
        generate_image: "이미지 생성",
        style_transfer: "화풍 변환",
        upscale: "업스케일링 (4K)",
        magic_eraser: "매직 이레이저",
        export: "내보내기",
        export_video: "영상 파일 (.mp4)",
        export_webtoon: "웹툰 원고 (.jpg)",
        export_scenario: "시나리오 대본 (.txt)",
        export_success: "내보내기가 완료되었습니다.",
        export_fail: "내보내기 실패"
    },
    intro: {
        slogan: "인간의 창의성, AI의 확장성",
        hero_title: "시네노벨을 위한",
        hero_subtitle: "바벨피쉬 (Babel Fish)",
        status_active: "실시간 번역 엔진 가동 중",
        status_cine: "시네노벨 포맷",
        desc_1: "비파괴 AI 엔진을 통해 한국의 IP를 <span class='text-white font-bold mx-1'>10개국어</span>로 즉시 읽어보세요.",
        desc_2: "비주얼과 소설이 융합된 <span class='text-white font-bold mx-1'>세계 최초 하이브리드 포맷</span>을 경험하세요.",
        cta_start: "무료로 감상하기",
        compare_title: "파괴적 번역 vs 비파괴 번역",
        compare_desc: "우리는 원본 픽셀을 절대 건드리지 않습니다. 그 차이를 확인하세요.",
        compare_old: "기존 방식 (식자/화이트박스)",
        compare_new: "설화 엔진 (R.A.P.S)",
        white_box_removed: "화이트박스 제거됨",
        format_title: "정지된 이미지를 넘어",
        format_desc: "웹툰의 비주얼. 소설의 깊이. 영화 같은 몰입감.",
        geo_title: "AI 주도형 성장",
        geo_desc: "우리는 마케팅을 하지 않습니다. AI가 대신합니다.",
        term_log_1: "콘텐츠 분석 중...",
        term_log_2: "핵심 키워드 추출 중...",
        term_log_3: "JSON-LD 메타데이터 주입 중...",
        term_log_4: "오가닉 성장률 +300%",
        slider_old_title: "기존 방식",
        slider_old_desc: "원작을 가리는 화이트박스",
        slider_new_title: "설화 엔진 (R.A.P.S)",
        slider_new_desc_1: "\"이것이 우리가 원했던 방식입니다.\"",
        slider_new_desc_2: "텍스트가 원화 위에 자연스럽게 떠오릅니다.",
        phone_analyzing: "분석 중...",
        phone_detected: "감지됨",
        phone_text_1: "이것이 나의 운명인가?",
        phone_cine_ep: "시네노벨 1화",
        phone_cine_text_1: "네온 사인이 깜빡이며 그의 차가운 눈동자에 반사되었다.",
        phone_cine_text_2: "\"단순한 번역이 아니야,\" 그가 중얼거렸다. \"새로운 현실이지.\"",
        footer_copyright: "Powered by R.A.P.S Engine."
    }
}
